import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchSmeDashboardSaga() {
  try {
    const mockData = {
      stats: {
        contentUploaded: 45,
        studentsReached: 2500,
        averageScore: 78,
        pendingApprovals: 3
      },
      recentUploads: [
        { id: 1, title: 'Advanced Algorithms Video', type: 'video', status: 'approved', uploadedAt: '2024-01-15' },
        { id: 2, title: 'Data Structures Quiz', type: 'quiz', status: 'pending', uploadedAt: '2024-01-14' },
        { id: 3, title: 'Programming Fundamentals', type: 'content', status: 'approved', uploadedAt: '2024-01-13' }
      ]
    };
    
    yield put(actions.fetchSmeDashboardSuccess(mockData));
  } catch (error) {
    yield put(actions.fetchSmeDashboardFailure(error.message));
  }
}

function* fetchSmeAnalyticsSaga() {
  try {
    const mockAnalytics = {
      monthlyStudents: [120, 150, 180, 220, 190, 250],
      contentPerformance: [
        { title: 'Programming Basics', views: 450, rating: 4.5 },
        { title: 'Data Structures', views: 380, rating: 4.2 },
        { title: 'Algorithms', views: 320, rating: 4.7 }
      ]
    };
    
    yield put(actions.fetchSmeAnalyticsSuccess(mockAnalytics));
  } catch (error) {
    yield put(actions.fetchSmeAnalyticsFailure(error.message));
  }
}

function* smeDashboardSaga() {
  yield takeEvery(types.FETCH_SME_DASHBOARD_REQUEST, fetchSmeDashboardSaga);
  yield takeEvery(types.FETCH_SME_ANALYTICS_REQUEST, fetchSmeAnalyticsSaga);
}

export default smeDashboardSaga;